import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import { useFeatureFlags } from './FeatureFlagContext';
import { featureFlagMenuAvailable } from './featureFlags';

type FeatureFlagMenuItemProps = {
  onClose: () => void;
};

export default function FeatureFlagMenuItem({
  onClose,
}: FeatureFlagMenuItemProps): JSX.Element | null {
  const { openOverlay } = useFeatureFlags();

  function handleClick(): void {
    onClose();
    openOverlay();
  }

  if (!featureFlagMenuAvailable()) return null;

  return (
    <ListItemButton onClick={handleClick}>
      <ListItemIcon>
        <FlagIcon />
      </ListItemIcon>
      <ListItemText primary="Feature flags" />
    </ListItemButton>
  );
}
